module.exports = __webpack_public_path__ + "static/img/autCt_bg_03.dd6bd46b.svg";